<div class="container">
  <div class="row">
    <div class="col-md-6" style="color:black; padding-top:1%; font-size:1.4em; font-weight:bold ">
      In re Generic Pharmaceuticals Antitrust Litigation
    </div>
    <div class="col-md-6">
      <div class="float-right phoneNumber" style="font-size: 1.4em; padding-top: 3%; font-weight: bold">1-877-316-0171</div>
    </div>
    <div class="col-md-12" style="padding-left:0px; padding-right:0px">
   
    </div>
  </div>
</div>
<header>
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #000042 ">
    <div class="container">
      <button class="navbar-toggler" type="button" style="background-color:white" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/landing']" style="color:white; font-weight:bold">All Classes Page</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/certified-litigation-classes-homepage']" style="color:white; font-weight:bold">Home</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/certified-litigation-classes-notice']" style="color:white; font-weight:bold">Notice/FAQs</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/certified-litigation-classes-courtdocuments']" style="color:white; font-weight:bold">Court Documents</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/register']" style="color:white; font-weight:bold">Registration</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/certified-litigation-classes-espanol']" style="color:white; font-weight:bold">Español</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/certified-litigation-classes-contact']" style="color:white; font-weight:bold">Contact Information</a>
          </li>

        </ul>
      </div>
    </div>
  </nav>

</header>
<div class="container" style="border:1px solid #bebaba">
  <div class="row text-center background-bottom">
    <div class="col-md-12 text-center img-fluid" style="margin-top:2%; margin-bottom:2%; padding-right:2%; padding-left:2%">
      <p class="text-center" style="font-size:1.0em; color:white">
        This official website is maintained by the Notice Administrator for <i>In re Generic Pharmaceuticals Antitrust Litigation</i>,
        No. 16-MD-2724 pending in the United States District Court for the Eastern District of Pennsylvania.
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 background">
      <img src="../assets/GNCC Blue Modas Header.jpg" class="img-fluid" />
      <a [routerLink]="'/register-home'">
        <img src="../assets/Button.png" alt="Register for Updates Here" class="img-fluid" style="width: 30%; margin-left: 330px; margin-right: -15px; margin-top: -80px; margin-bottom: 4%;" />
      </a>
    </div>
  </div>

  <br />
  <br />
  <div class="row" style="margin-left:5%;margin-right:5%">
    <div class="col-md-12" style="text-align:justify;">

      <b>Your legal rights may be affected by two class action lawsuits (part of In re Generic Pharmaceuticals Antitrust Litigation, No. 16-MD-2724 (E.D. Pa)).</b> The lawsuits claim
      that Defendant generic drug manufacturers violated federal and state antitrust and consumer protection laws, causing End-Payers – Third-Party Payers such as insurers and
      employers with self-funded prescription drug plans – to pay more than they should have for Clobetasol and Clomipramine. The Defendants deny that they are liable. The Court has
      not decided who is right. On March 7, 2025, the Court ordered that these cases should proceed as class actions, and that order has been appealed to the Third Circuit. I
      f that order is upheld on appeal, and the Lawsuits are not dismissed or settled, the End-Payer Class Representatives will have to prove their claims at trials, to be scheduled
      at a future date.<br /><br />

      The information contained on this website is only a summary. You may download a copy of the full Notice by clicking
      <a href="./assets/Docs/Notice/Clob.Clom LF Notice 5-6-2025.pdf" target="_blank">here</a>. Since this website is just a
      summary, you should review the Notice for additional details.<br /><br />


      <b>Am I included? </b><br /><br />

      This lawsuit was brought by Third-Party Payers (“TPPs”) who were End-Payers (“EPPs”) for generic Clobetasol and Clomipramine, and the Court has now
      certified EPP Classes that consist of TPPs. You may be a member of the EPP Classes if you indirectly paid and/or provided reimbursement for some or
      all of the purchase price for generic Clobetasol or Clomipramine, other than for resale, in Alaska, Arizona, Arkansas, California, Colorado, Connecticut,
      Delaware, the District of Columbia, Florida, Hawaii, Iowa, Kansas, Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Nebraska,
      Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina, North Dakota, Oregon, Rhode Island, South Dakota, Tennessee, Utah, Vermont,
      Virginia, West Virginia, Wisconsin, or the U.S. Virgin Islands, at any time during the periods from September 1, 2014 through December 31,
      2018 (Clobetasol) or August 1, 2013 through December 31, 2018 (Clomipramine). Some entities and purchases are excluded. A more detailed notice that
      includes the full class descriptions and who is or is not included, as well as the complaints and other important documents, are available on
      this website.
    </div>
  </div>
  <br />
  <div class="table-responsive">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th colspan="2" style="background-color: #000042; color: white; font-weight: bold; font-size: 1.4em; text-align: center;">
            YOUR RIGHTS AND OPTIONS
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="background-color: #000042; text-align: center; font-weight: bold; color: white; vertical-align: middle; width: 20% ">
            <!--STAY IN THE CLASSES-->
            DO NOTHING
          </td>
          <td style="background-color:white; color:#3e4144; width:60%">
            You do not need to do anything to stay in the Classes. If you stay in the Classes, you keep the possibility of getting money or benefits that may come from a trial(s).
            You will be bound by all Court rulings, including any determinations against the EPPs. You will also give up any rights to sue the Defendants separately about the
            same legal claims in these Lawsuits.<br /><br />

            The deadline for you to exclude yourself, or “opt out” of the Classes has passed.


            <!--You do not need to do anything to stay in the Classes. If you stay in the Classes, you keep the possibility of getting money or benefits that may
  come from a trial(s). You will be bound by all Court rulings, including any determinations against the EPPs. You will also give up any rights to
  sue the Defendants separately about the same legal claims in these Lawsuits.-->
          </td>
        </tr>
        <tr>
          <td style="background-color: #000042; text-align: center; font-weight: bold; color: white; vertical-align: middle; ">
            GET MORE INFORMATION
            <!--EXCLUDE YOURSELF FROM THE CLASSES-->
          </td>
          <td style="background-color:white; color:#3e4144;">
            If you would like to obtain more information about the Lawsuit, you can review the materials on the <br /><a [routerLink]="'/certified-litigation-classes-courtdocuments'">Court Documents</a> page, or send questions to the Notice Administrator at <a href="mailto:info@genericdrugsendpayersettlement.com">info@genericdrugsendpayersettlement.com</a>.<br /><br />

            Updates regarding this litigation will be posted to this website. You may also register for updates <a [routerLink]="'/register-home'">here</a>.


            <!--You may choose to exclude yourself, or “opt out,” from one or more of the Classes. If you decide to exclude yourself, you will not be bound by
  any future decisions affecting Classes from which you are excluded, including the results of trials. This is the only option that allows you to
  ever be part of any lawsuit (other than these Lawsuits) against the Defendants about the same legal claims in this case.<br /><br />

  If you choose to exclude yourself, you will not receive any money or benefits that may result if the Classes prevail at trial.<br /><br />

  Details on how to submit a valid request for exclusion are explained in Question 9 of the Notice. Requests for exclusion must be <u>postmarked</u> by
  <b>July 5, 2025</b>.-->
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <br />
  <!--<div class="row" style="margin-left:5%;margin-right:5%">
    <div class="col-md-12" style="text-align:justify;">
      <p style="font-size:1.0em">

        <b>More Information</b><br /><br />

        If you would like to obtain more information about the Lawsuit, you can review the materials on the <a [routerLink]="'/certified-litigation-classes-courtdocuments'">Court Documents</a>, or send questions to the Notice Administrator at <a href="mailto:info@genericdrugsendpayersettlement.com">info@genericdrugsendpayersettlement.com</a>.
        Updates regarding this litigation will be posted to this website. You may also register for updates <a [routerLink]="'/register-home'">here</a>.
      </p>
      <br />
    </div>
  </div>-->
</div>
